import * as types from './index';

export const crewListAction = (data) => {
    return {
    type: types.CREW_LIST,
    data
    }
};

export const crewAllListAction = (data) => {
    return {
    type: types.CREW_ALL_LIST,
    data
    }
};


export const crewBasicInfoAddAction = (data) => {
    return {
    type: types.CREW_BASIC_INFO_ADD,
    data
    }
};

export const crewBasicInfoUpdateAction = (data) => {
    return {
    type: types.CREW_BASIC_INFO_UPDATE,
    data
    }
};

export const crewEditAction = (data) => {
    return {
    type: types.CREW_EDIT,
    data
    }
};

export const crewChangeAvailabilityAction = (data) => {
    return {
    type: types.CREW_AVAILABILITY,
    data
    }
};

export const crewApproveAction = (data) => {
    return {
    type: types.CREW_APPROVE,
    data
    }
};

export const crewChiefEligibleAction = (data) => {
    return {
    type: types.CREW_CHIEF_APPROVE,
    data
    }
};

export const crewActiveDeactiveAction = (data) => {
    return {
    type: types.CREW_ACTIVE_DEACTIVE,
    data
    }
};

export const crewSkillListAction = (data) => {
    return {
    type: types.CREW_SKILL_LIST,
    data
    }
};

export const crewSkillSaveAction = (data) => {
    return {
    type: types.CREW_SKILL_SAVE,
    data
    }
};

export const crewAffSkillListAction = (data) => {
    return {
    type: types.CREW_AFFILIATE_SKILL_LIST,
    data
    }
};

export const crewImportAction = (data) => {
    return {
    type: types.CREW_IMPORT,
    data
    }
};

export const crewScheduleShiftStatusAction = (data) => {
    return {
    type: types.CREW_SCHEDULE_SHIFT_STATUS,
    data
    }
};

export const crewScheduleShiftCheckInAction = (data) => {
    return {
    type: types.CREW_SCHEDULE_SHIFT_CHECKIN,
    data
    }
};

export const crewScheduleShiftCheckOutAction = (data) => {
    return {
    type: types.CREW_SCHEDULE_SHIFT_CHECKOUT,
    data
    }
}; 

export const crewRemovalFromShiftAction = (data) => {
    return {
    type: types.CREW_REMOVAL_FROM_SHIFT,
    data
    }
}; 

export const crewInductionAction = (data) => {
    return {
    type: types.CREW_INDUCTION,
    data
    }
};


export const crewProfileActiveTabAction = (data) => {
    return {
    type: types.CREW_PROFILE_TAB_ACTIVE,  
    data
    }
};

export const crewProfileDeactiveTabAction = (data) => {
    return {
    type: types.CREW_PROFILE_TAB_DEACTIVE,
    data
    }
};

export const crewListDownloadAction = (data) => {
    return {
    type: types.CREW_LIST_DOWNLOAD,
    data
    }
};

// TO SET ACTIVE CREW ID FROM LOG LISTING WHILE CLICK ON CREW NAME 
export const crewListSetSliderCrewId = (data) => {
    return {
        type: types.CREW_LIST_SLIDER_CREWID,
        data
    }
}; 

export const crewTimesheetListAction = (data) => {
    return {
    type: types.CREW_TIMESHEET_LIST,
    data
    }
};

export const crewFeedbackListAction = (data) => {
    return {
    type: types.CREW_FEEDBACK_LIST,
    data
    }
};

export const crewUnapprovedCountAction = (data) => {
    return {
    type: types.CREW_UNAPPROVED_COUNT
    }
};

export const crewNotesListAction = (data) => {
    return {
    type: types.CREW_NOTES_LIST,
    data
    }
};

export const crewNotesAddAction = (data) => {
    return {
    type: types.CREW_NOTES_ADD,
    data
    }
};

export const crewNotesDocumentAddAction = (data) => {
    return {
    type: types.CREW_NOTES_DOCUMENT_ADD,
    data
    }
};

export const crewNotesDocumentDeleteAction = (data) => {
    return {
    type: types.CREW_NOTES_DOCUMENT_DELETE,
    data
    }
};
